export default {
  // Style prefix
  stylePrefix: 'css-',

  // Custom CSS string to render on top
  staticRules: '',

  // Default CSS style
  rules: []
};



// WEBPACK FOOTER //
// webpack://grapesjs/src/css_composer/config/config.js